<template>
    <b-container>
        <b-row>
            <b-col offset="3" cols="6">
                <mainWire-add-form v-if="store.state[STORE_MODULE_NAME].elementInEdit == null"></mainWire-add-form>
                <mainWire-update-form v-else="store.state[STORE_MODULE_NAME].elementInEdit != null"></mainWire-update-form>
            </b-col>
        </b-row>
    </b-container>
</template>


<script>


    import store from '@/store'

    import MainWireAddForm from './forms/add/representations/WizardForm'
    import MainWireUpdateForm from './forms/update/representations/WizardForm'

    import {BContainer, BRow, BCol} from 'bootstrap-vue'

    import { STORE_MODULE_NAME } from '../mainWireStoreModule'

    export default {


        setup() {

            return {
                store,
                STORE_MODULE_NAME,
            }
        },

        components:{

            BContainer, BRow, BCol,
            MainWireAddForm,
            MainWireUpdateForm
        },

    }
</script>
